// libs
import React, { memo, useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
// widgets
import Placement from './widgets/Placement';
import Preference from './widgets/Preference';
import Products from './widgets/Products';
import Keywords from './widgets/Keywords';
import Budget from './widgets/Budget';
import WarningNudge from './widgets/WarningNudge';
import Tile from '@/widgets/Tile';
import ModalContent from './widgets/ModalContent';
// components
import Modal from '@/components/Modal/Modal';
// styles
import styles from './ReviewCampaign.module.scss';
// stores
import useWriteCampaignStore from '@/stores/WriteCampaign';
import useConfigStore from '@/stores/Configs';
// hooks
import useNudge from '@/hooks/useNudge';
const CampaignPreview = ({ mode, setStepperActiveStep, campaignOperation, showWarningModal, setShowWarningModal, }) => {
    const { name, setName, type, adGroupCandidates, pacingEnabled, adGroupCityIds, adGroupDaysOfWeek, adGroupKeywords, adGroupMealSlots, startDate, endDate, budget, } = useWriteCampaignStore((state) => ({
        name: state.name,
        setName: state.setName,
        type: state.type,
        adGroupCandidates: state.adGroups[0].candidates,
        pacingEnabled: state.pacingEnabled,
        adGroupDaysOfWeek: state.adGroups[0].daysOfWeek,
        adGroupMealSlots: state.adGroups[0].mealSlots,
        adGroupKeywords: state.adGroups[0].keywords,
        adGroupCityIds: state.cityIds,
        startDate: state.startDate,
        endDate: state.endDate,
        budget: state.budget,
    }), shallow);
    const { isAnyNudgeVisible } = useNudge(mode === CampaignWriteModeEnum.EDIT);
    const cityOptions = useConfigStore((store) => store.cities);
    const [showWarning, setShowWarning] = useState(false);
    useEffect(() => {
        if (isAnyNudgeVisible) {
            setShowWarning(true);
        }
    }, [adGroupCandidates, adGroupCityIds, adGroupKeywords]);
    const setActiveStep = (step) => {
        setStepperActiveStep === null || setStepperActiveStep === void 0 ? void 0 : setStepperActiveStep(step);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { Content: ModalContent, contentProps: { campaignOperation, setShowWarningModal }, closeOnOutsideClick: true, open: !!showWarningModal, setOpen: setShowWarningModal }),
        showWarning && (React.createElement(WarningNudge, { adGroupCandidates: adGroupCandidates.length, adGroupCityIds: adGroupCityIds.length, adGroupKeywords: adGroupKeywords.length, onClose: () => setShowWarning(false), setActiveStep: setActiveStep, mode: mode })),
        React.createElement(Tile, { className: cx(styles.tile, {
                [styles.tileNudge]: showWarning,
            }) },
            React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.containerHeader },
                    React.createElement(Text, { className: styles.containerHeaderTitle, variant: DlsFontVariants.header_H3_Black }, "Review your information"),
                    React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis },
                        "Review your Campaign information and click submit to",
                        ' ',
                        mode === CampaignWriteModeEnum.EDIT
                            ? 'update'
                            : 'activate',
                        ' ',
                        "your campaign.")),
                React.createElement("div", { className: styles.summary },
                    React.createElement(Placement, { className: styles.summaryChild, name: name, type: type, mode: mode, onNameChange: setName, setActiveStep: setActiveStep }),
                    React.createElement(Preference, { className: styles.summaryChild, startDate: startDate, endDate: endDate, cityIds: adGroupCityIds, daysOfWeek: adGroupDaysOfWeek, mealSlots: adGroupMealSlots, setActiveStep: setActiveStep, cityOptions: cityOptions })),
                React.createElement(Products, { products: adGroupCandidates, setActiveStep: setActiveStep }),
                React.createElement(Keywords, { keywords: adGroupKeywords, setActiveStep: setActiveStep }),
                React.createElement(Budget, { budget: budget, pacingEnabled: pacingEnabled, setActiveStep: setActiveStep })))));
};
export default memo(CampaignPreview);
